export default __webpack_public_path__ + "static/shape2-05990c9a00a58fb4edbb8af92179d6b7.png";